import {
  Backdrop,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import { useSnackbar } from "notistack";
import { useContext, useEffect, useState } from "react";
import "../../../../Tooltip/styles/tooltip.css";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import { useUpdateFolderName } from "../FileQueries/updateFolderName.jsx";
import "./styles/create-folder-popover.css";

// Create a new folder popover
const RenameFolderPopover = ({
  open,
  setOpen,
  projectId,
  queryClient,
  userType,
  folder,
}) => {
  const { isAdmin, clientId } = useContext(DashboardContext);
  const [folderState, setFolderState] = useState({
    id: null,
    name: "",
    displayName: "",
  });
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const updateFolderName = useUpdateFolderName(
    queryClient,
    projectId,
    userType,
    enqueueSnackbar,
    setOpen,
  );

  const handleClose = () => {
    setFolderState({
      id: null,
      name: "",
      displayName: "",
    });
    setOpen(false);
  };

  useEffect(() => console.log("FOLDER: ", folder), [folder]);

  const convertToCamelCase = (str) => {
    // Should convert "New Folder Name" to "newFolderName" and Noi to noi
    return str
      .replace(/[^a-zA-Z0-9 ]/g, "") // Remove special characters except spaces
      .split(" ")
      .map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      )
      .join("");
  };

  return (
    <Modal id="create-folder-modal" open={open} onClose={handleClose}>
      <div id="create-folder-form">
        <Backdrop id="create-folder-backdrop" open={openBackdrop}>
          CREATING FOLDER DO NOT LEAVE THIS PAGE
          <CircularProgress id="create-folder-progress" />
        </Backdrop>
        <h1 id="create-folder-heading">Create New Folder</h1>
        <FormControl
          id="folder-form-control"
          className="folder-form-control"
          variant="outlined"
          classes={{
            root: "folder-form-root",
          }}
        >
          <InputLabel
            id="folder-field-label"
            classes={{
              shrink: "input-folder-label-shrink",
            }}
            htmlFor="folder-name-input"
          >
            Folder Name
          </InputLabel>
          <OutlinedInput
            type="text"
            id="folder-text"
            value={folderState.displayName}
            onChange={(e) =>
              setFolderState({
                ...folderState,
                displayName: e.target.value,
                name: convertToCamelCase(e.target.value),
              })
            }
            label="Folder Name"
            classes={{
              root: "input-folder-root",
              notchedOutline: "input-folder-notched-outline",
              input: "input-folder-input",
            }}
            autoComplete="off"
          />
        </FormControl>
        <div id="create-folder-btns-container">
          <Button
            id="create-folder-cancel-btn"
            className="create-folder-btn"
            variant="contained"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            id="create-folder-create-btn"
            className="create-folder-btn"
            variant="contained"
            onClick={async () => {
              setOpenBackdrop(true);
              await updateFolderName.mutateAsync({
                projectId,
                folder: folder,
                name: folderState.name,
                displayName: folderState.displayName,
              });
              setOpenBackdrop(false);
            }}
          >
            Update
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RenameFolderPopover;
